import { ReactNode } from 'react';

import styles from './DocumentImportSectionHeader.module.less';

interface DocumentImportSectionHeaderProps {
  title: string;
  count: number;
  icon: ReactNode;
  testId?: string;
}

export const DocumentImportSectionHeader = ({
  title,
  count,
  icon,
  testId,
}: DocumentImportSectionHeaderProps) => {
  return (
    <div className={styles.sectionHeader} data-testid={testId ? `${testId}-header` : undefined}>
      <span className={styles.icon}>{icon}</span>
      <span className={styles.title} data-testid={testId ? `${testId}-title` : undefined}>
        {title} ({count})
      </span>
    </div>
  );
};
